// Constantes d'autorités Spring Security (les codes menu-item vivent dans utils/roles.json).
export const ADMIN_ROLES = ['ROLE_ADMIN', 'ROLE_SUPERADMIN']

export const SHAREHOLDER_ROLES = ['ROLE_ADMIN', 'ROLE_STAFF', 'ROLE_MEMBER', 'ROLE_MEMBERSHIP']

export const PERSON_MANAGE_ROLES = ['ROLE_ADMIN', 'ROLE_POSTHOLDER']

export const MDM_ADMIN_ROLES = ['ROLE_ADMIN', 'ROLE_IT_MANAGER']

export const ACCOUNTING_MANAGER_ROLES = ['ROLE_ACCOUNTING_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERADMIN']

export const PROSPECT_MANAGER_ROLES = ['ROLE_SALES_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERADMIN']

// Mêmes rôles que SecurityService.isLeaveManager côté serveur.
export const LEAVE_REQUEST_ADMIN_ROLES = [
  'ROLE_ADMIN',
  'ROLE_SUPERADMIN',
  'ROLE_LEAVE_VALIDATOR',
  'ROLE_HR',
  'ROLE_HR_MANAGER',
]

export const LEAVE_REQUEST_VALIDATOR_ROLES = ['ROLE_LEAVE_VALIDATOR']

// Hors hiérarchie : tester par authorities.has, hasAuthority laisserait passer un superadmin que le serveur refuse.
export const BANK_ACCOUNT_VALIDATOR_ROLE = 'ROLE_BANK_ACCOUNT_VALIDATOR'

export const CREW_DUTY_MANAGER_ROLES = [
  'ROLE_ADMIN',
  'ROLE_SUPERADMIN',
  'ROLE_OPS',
  'ROLE_GROUND_OPS_MANAGER',
]

// Édition d'un UserAgendaEvent depuis l'agenda ops. Le serveur s'appuie sur la hiérarchie
// (ROLE_OPS suffit, tout ce qui est au-dessus en hérite) ; côté client les rôles sont ceux
// réellement assignés, donc la chaîne est listée en entier.
export const AGENDA_EVENT_EDIT_ROLES = [
  'ROLE_ADMIN',
  'ROLE_SUPERADMIN',
  'ROLE_STAFF',
  'ROLE_GROUND_OPS_MANAGER',
  'ROLE_OPS',
]

// Ouvre aussi l'écriture sur les indisponibilités du collègue, pas seulement la consultation.
export const PLANNING_VIEW_OTHERS_ROLES = ['ROLE_STAFF', 'ROLE_ADMIN', 'ROLE_SUPERADMIN']

// Valeur historique : rôle unique, pas de tableau (cf. RosterAgendaContext).
export const ROSTER_MANUAL_CHANGE_ROLES = 'ROLE_ROSTER_CHANGE'

// Appels de volontaires : la chaîne Ops (hiérarchie serveur) plus le droit de modifier le roster.
export const VOLUNTEER_CALL_MANAGE_ROLES = [...AGENDA_EVENT_EDIT_ROLES, ROSTER_MANUAL_CHANGE_ROLES]

export const isMemberOnly = (roles: string[]): boolean =>
  roles.length > 0 && roles.every((role) => role === 'ROLE_MEMBER')

// Rôles qui donnent ROLE_USER ou ROLE_MEMBER par la hiérarchie serveur (application.groovy) : côté client
// les rôles sont ceux attribués, sans expansion. Un compte qui n'en porte aucun (client CAMO, inspecteur
// NAA) ne démarre que le strict nécessaire — ni sélecteur d'entité, ni tâches, ni push, ni recherche.
export const BASE_ROLE_HOLDERS = [
  'ROLE_SUPERADMIN',
  'ROLE_ADMIN',
  'ROLE_STAFF',
  'ROLE_GROUND_OPS_MANAGER',
  'ROLE_OPS',
  'ROLE_PILOT',
  'ROLE_IT_MANAGER',
  'ROLE_SALES_MANAGER',
  'ROLE_SALES',
  'ROLE_ACCOUNTING_MANAGER',
  'ROLE_ACCOUNTING',
  'ROLE_HR_MANAGER',
  'ROLE_HR',
  'ROLE_MEMBERSHIP',
  'ROLE_TRAINING',
  'ROLE_DOCUMENTATION_ADMIN',
  'ROLE_STOCK_MANAGER',
  'ROLE_STOCK',
  'ROLE_PROCUREMENT',
  'ROLE_USER',
  'ROLE_MEMBER',
]

export const hasBaseRole = (roles: string[] | undefined): boolean =>
  (roles ?? []).some((role) => BASE_ROLE_HOLDERS.includes(role))

// Page d'arrivée : le tableau de bord pour un collaborateur ou un membre ; sinon la première entrée de
// menu racine du profil (« role--maintenance » → /maintenance), /maintenance/aircraft à défaut.
export const landingRoute = (
  roles: string[] | undefined,
  profileRoles: { menuItems?: { code: string }[] }[] | undefined,
): string => {
  if (hasBaseRole(roles)) {
    return '/dashboard'
  }

  const rootMenuItem = (profileRoles ?? [])
    .flatMap((role) => role.menuItems ?? [])
    .map((menuItem) => menuItem.code)
    .find((code) => /^role--[a-z-]+$/.test(code) && !code.slice('role--'.length).includes('--'))

  return rootMenuItem ? `/${rootMenuItem.slice('role--'.length)}` : '/maintenance/aircraft'
}
